import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Marquee from "../components/site/Marquee";
import Differentials from "../components/site/Differentials";
import About from "../components/site/About";
import Parish from "../components/site/Parish";
import Outdoor from "../components/site/Outdoor";
import Process from "../components/site/Process";
import Modalities from "../components/site/Modalities";
import NearMe from "../components/site/NearMe";
import WeddingsSection from "../components/site/WeddingsSection";
import PartnersTeaser from "../components/site/PartnersTeaser";
import GallerySection from "../components/site/GallerySection";
import Testimonials from "../components/site/Testimonials";
import BlogPreview from "../components/site/BlogPreview";
import AvailabilityForm from "../components/site/AvailabilityForm";
import EditorialQA from "../components/site/EditorialQA";
import Pricing from "../components/site/Pricing";
import FAQ from "../components/site/FAQ";
import Footer from "../components/site/Footer";
import FloatingWhatsApp from "../components/site/FloatingWhatsApp";
import Seo from "../lib/seo";
import { scrollToId } from "../components/site/shared";
import { useSite } from "../context/SiteContext";

export default function Home() {
  const location = useLocation();
  const { content } = useSite();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => scrollToId(location.hash.slice(1)), 400);
    }
  }, [location.hash]);

  return (
    <div className="bg-cream" data-testid="home-page">
      <Seo
        title={content?.seo?.title}
        description={content?.seo?.description}
        canonicalPath="/"
        jsonld={content?.faq?.length ? {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: content.faq.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        } : null}
      />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Differentials />
        <About />
        <Parish />
        <Outdoor />
        <Process />
        <Modalities />
        <WeddingsSection />
        <PartnersTeaser />
        {/* Seções abaixo da dobra montam sob demanda ao rolar (JS e imagens fora do boot).
            O conteúdo SEO permanece no HTML estático servido aos buscadores. */}
        <LazySection><NearMe /></LazySection>
        <LazySection><GallerySection /></LazySection>
        <LazySection><Testimonials /></LazySection>
        <LazySection><BlogPreview /></LazySection>
        <LazySection><AvailabilityForm /></LazySection>
        <LazySection><Pricing /></LazySection>
        <LazySection><EditorialQA /></LazySection>
        <LazySection><FAQ /></LazySection>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

function LazySection({ children }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || show) return;
    const ob = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          ob.disconnect();
        }
      },
      { rootMargin: "900px" }
    );
    ob.observe(el);
    return () => ob.disconnect();
  }, [show]);
  return <div ref={ref}>{show ? children : <div className="min-h-[320px]" aria-hidden="true" />}</div>;
}
